
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import { signupUpdateRecourdList, signupUpdateRecourdCount } from '@/api/ordercenter'
import util from '@/utils/busi/util'

@Component({
  name: 'updatelog',
  components: {
    SimpleTable
  }
})

export default class UpdateLog extends Vue {
  private params = util.getRouterParams()

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'fieldName',
    label: '字段'
  },
  {
    prop: 'oldValue',
    label: '原值'
  },
  {
    prop: 'newValue',
    label: '新值'
  },
  {
    prop: 'createName',
    label: '操作人员'
  },
  {
    prop: 'createTime',
    label: '更新时间',
    format: 'date'
  }]

  private dialogVisible = !1

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  beforeMount () {
    this.initData()
  }

  private async initData (pagination: any = null) {
    await signupUpdateRecourdList({
      signupId: this.params.id,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      if (res.code === 10000) {
        await signupUpdateRecourdCount({
          signupId: this.params.id
        }).then((resCnt: any) => {
          this.tableData.list = res.object.list
          this.tableData.totalCount = resCnt.object.count
        })
      }
    })
  }
}
